import { type AppThunk } from 'services/redux/configureStore';

import { tasksBoardApi } from '../../api/tasksBoardApi';
import { type CommentWithTaskInfo } from '../../api/tasksBoardTypes';
import { markAsViewed } from '../slices/newCommentsSlice';
import { changeTaskUnreadCommentsCount } from '../slices/tasks/tasksSlice';

type TaskId = number;
type CommentId = number;

export const readAllNewCommentsThunk =
  (allComments: CommentWithTaskInfo[]): AppThunk<Promise<{ success: boolean }>> =>
  async (dispatch) => {
    const unreadComments = allComments.filter((comment) => !comment.isViewed);

    const commentsByTasks: Record<TaskId, CommentId[]> = {};

    for (const comment of unreadComments) {
      const taskId = comment.task.id;

      if (!commentsByTasks[taskId]) {
        commentsByTasks[taskId] = [];
      }

      commentsByTasks[taskId].push(comment.id);
    }

    const entries = Object.entries(commentsByTasks);

    const results = await Promise.allSettled(
      entries.map(([taskId, ids]) =>
        dispatch(
          tasksBoardApi.endpoints.readBoardTaskComments.initiate({
            taskId: Number(taskId),
            commentsIds: ids,
          })
        ).unwrap()
      )
    );

    let hasError = false;

    results.forEach((result, index) => {
      if (result.status === 'fulfilled') {
        const [taskId, ids] = entries[index];

        dispatch(markAsViewed({ ids }));
        dispatch(changeTaskUnreadCommentsCount({ taskId: Number(taskId), delta: -ids.length }));
      } else {
        hasError = true;
      }
    });

    return { success: !hasError };
  };
